module.exports = __webpack_public_path__ + "img/page4_blur.f8cce99e.png";